import * as pointColors from '../../assets/styles/variables/colors.scss'

export default {
    moreOptions:{
        menuItem: {
            color: pointColors.gray400
        },
    }
}